<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_iii"></a><strong><em>The Marquis de Sade</em></strong></h1>
<p class="subtitle"><em>The 120 Days of Sodom and other writings</em></p>
<p class="edition"><span class="small">COMPILED AND TRANSLATED BY</span></p>
<p class="author">A<span class="small">USTRYN</span> W<span class="small">AINHOUSE</span> &amp; R<span class="small">ICHARD</span> S<span class="small">EAVER</span></p>
<p class="edition"><span class="small">WITH INTRODUCTIONS BY</span></p>
<p class="author">S<span class="small">IMONE DE</span> B<span class="small">EAUVOIR</span> &amp; P<span class="small">IERRE</span> K<span class="small">LOSSOWSKI</span></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?9af2c4d2